import React, { useCallback, useEffect, useState } from 'react';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import Button from '../../shared/components/ui/Button';
import Search from '../../shared/components/ui/Search';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import { transformData } from '../../super-admin/utils/transformData';
import Modal from '../../shared/components/ui/Modal';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { filterData } from '../../shared/utils/filterData';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getRequirements,
  handleCheckRequirementDelete,
  deleteRequirement,
  createRFQ,
  getMyVendors
} from '../services/api/implementation/impl';
import NoDataFound from '../components/layout/NoDataFound';
import PaginationComponent from '../../shared/components/PaginationComponent';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import editIcon from '../../shared/assets/svg/edit.svg';
import deleteIcon from '../../shared/assets/svg/delete.svg';
import viewIcon from '../../shared/assets/svg/view.svg';
import noDataFoundImg from '../../shared/assets/png/noDataFound.png';
import RFQForm from '../components/forms/RFQForm';

// Dummy data for item requirements
const initialRequirements = [
  {
    id: 1,
    project_name: 'Suman Vihar',
    raised_by: 'John Doe',
    requirements: 'White Cement',
    task: 'Task 1',
    is_active: true,
    status: 'Pending'
  },
  {
    id: 2,
    project_name: 'Sky Life',
    raised_by: 'Jane Doe',
    requirements: 'Brick',
    task: 'Task 2',
    is_active: true,
    status: 'Accepted'
  }
];

const RequirementList = () => {
  const userId = Cookies.get('userId');
  const navigate = useNavigate();
  const [isOpenAddRequirement, setIsOpenAddRequirement] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState();
  const [openRequestQuotation, setOpenRequestQuotation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem('requirementListActiveTab') || 'requirements'
  );
  const { collapsed } = useSidebar();

  // RFQ related state
  const [isRFQModalOpen, setIsRFQModalOpen] = useState(false);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [itemQuantities, setItemQuantities] = useState({});
  const [selectedItemsForRFQ, setSelectedItemsForRFQ] = useState([]);
  const [rfqProjectId, setRfqProjectId] = useState(null);
  const [rfqRequirementId, setRfqRequirementId] = useState(null);

  // pagination
  const [limit] = useState(100000); // items per page

  const {
    data: getAllrequiremnt,
    refetch: refetchRequiremnt,
    isFetching
  } = useQuery({
    queryKey: ['requirement', activeTab],
    queryFn: () => getRequirements(1, limit, activeTab),
    keepPreviousData: true
  });

  // Get vendors for RFQ
  const { data: allVendors, isLoading: isLoadingVendors } = useQuery({
    queryKey: ['allVendors'],
    queryFn: () => getMyVendors(1, 1000000),
    enabled: activeTab === 'emergency'
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    getAllrequiremnt?.data && getAllrequiremnt?.data?.length > 0
      ? getAllrequiremnt?.data?.slice(indexOfFirstItem, indexOfLastItem)
      : [];
  const handlePageChange = (newPage) => {
    setSearchQuery('');
    setCurrentPage(newPage);
  };

  // Track page view
  useEffect(() => {
    mixpanel.track('Requirement List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    refetchRequiremnt();
  }, [refetchRequiremnt]);

  console.log({ getAllrequiremnt });

  // Form handling using react-hook-form
  const { reset } = useForm();

  const handleSearch = (data) => {
    setSearchQuery(data);
  };

  // const handleOnClickSearch = () => {
  //   const filtered = getAllrequiremnt.filter((item) =>
  //     item?.project?.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );

  //   setFilteredData(filtered);
  //   setSearchQuery('');
  // };

  const handleToggleAddRequirement = () => {
    setIsOpenAddRequirement(!isOpenAddRequirement);
  };

  const handleNavigateRequirement = (id) => {
    navigate(`/builder/inventory/requirements/${id}`);
  };

  const handleDeleteRequirement = (requirementId) => {
    const updatedRequirements = filteredData.filter(
      (requirement) => requirement.id !== requirementId
    );
    setFilteredData(updatedRequirements);
    toast.success('Requirement deleted successfully');
  };

  const requirementsDataFormat = [
    'id',
    'project_name',
    'raised_by',
    'task',
    'requirements',
    'status',
    'actions'
  ];

  const onSubmit_Requirement = (data) => {
    // Add logic to handle form submission (e.g., API call)
    setIsOpenAddRequirement(false);
    toast.success('Requirement created successfully');
    reset();
  };

  const handleSearchChange = useCallback((incomingQuery) => {
    if (incomingQuery) {
      const filteredRequirements = filterData('name', getAllrequiremnt?.data, incomingQuery);
      setFilteredData(filteredRequirements);
    } else {
      setFilteredData(initialRequirements);
    }
  }, []);

  const handleRequirementFormat = (item) => {
    return {
      id: item.id,
      project_name: item?.project?.name || ' ',
      raised_by: item?.user?.name || ' ',
      task: item?.task?.name || ' ',
      requirements: item?.vendorRequirmentMappingItems?.length || 0,
      status: item.status || ' '
    };
  };

  const transformedData = currentItems.map((item) =>
    transformData(handleRequirementFormat(item), requirementsDataFormat)
  );

  const transformedList = getAllrequiremnt?.data?.map((item) =>
    transformData(handleRequirementFormat(item), requirementsDataFormat)
  );

  //delete functions

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckRequirementDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const requirement = getAllrequiremnt?.data?.find(
        (item) => parseInt(item.id) === parseInt(id)
      );

      const requirementName = requirement?.task?.jobTitle || 'requirement';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: requirementName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: requirementName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking requirement', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking requirement');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteRequirement(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Requirement Deleted Successfully');

      // Refetch the data
      const result = await refetchRequiremnt();

      // Check if the current page is now empty
      const updatedData = result?.data?.data || [];
      const totalItems = updatedData.length;
      const totalPages = Math.ceil(totalItems / itemsPerPage);

      if (currentPage > totalPages && totalPages > 0) {
        setCurrentPage(totalPages); // Go to last valid page
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting requirement', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting requirement');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  // handle tab changes and persist in localStorage
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('requirementListActiveTab', tab);
  };

  // RFQ related functions
  const transformedVendors =
    allVendors?.data?.map((vendor) => ({
      name: vendor?.user?.name || '',
      id: vendor?.id
    })) || [];

  // Handle RFQ modal open
  const handleRFQClick = (id, event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!id) {
      console.error('Invalid item for RFQ');
      return;
    }

    // Find original requirement from source data
    const original = getAllrequiremnt?.data?.find((it) => Number(it.id) === Number(id));
    if (!original) {
      console.error('Requirement not found for RFQ');
      return;
    }

    const mappings = original?.vendorRequirmentMappingItems || [];
    // Prepare items array enriched with mapping quantity/unit for display
    const itemsForRfq = mappings.map((m) => ({
      ...(m?.items || {}),
      mappingQuantity: m?.quantity,
      mappingUnit: m?.unit
    }));
    setSelectedItemsForRFQ(itemsForRfq);
    setRfqProjectId(original?.project?.id || null);
    setRfqRequirementId(id);

    // Initialize quantities per item id, defaulting to mapping quantity
    const initialQuantities = {};
    mappings.forEach((m) => {
      const itmId = m?.items?.id;
      if (itmId) {
        initialQuantities[itmId] = itemQuantities[itmId] || m?.quantity || '';
      }
    });
    setItemQuantities(initialQuantities);

    setIsRFQModalOpen(true);
  };

  // Handle vendor selection
  const handleVendorSelect = (selectedList) => {
    const vendorIds = selectedList.map((vendor) => vendor.id);
    setSelectedVendors(vendorIds);
  };

  // Handle quantity change
  const handleQuantityChange = (itemId, quantity) => {
    setItemQuantities((prev) => ({
      ...prev,
      [itemId]: quantity
    }));
  };

  // Handle RFQ submit
  const handleRFQSubmit = async (formPayload) => {
    // Validate vendor selection
    if (selectedVendors.length === 0) {
      toast.error('Please select at least one vendor');
      return;
    }

    // Validate quantities
    const invalidItems = selectedItemsForRFQ.filter((item) => {
      const quantity = itemQuantities[item.id];
      return !quantity || quantity <= 0;
    });

    if (invalidItems.length > 0) {
      toast.error('Please enter a quantity greater than 0 for all items');
      return;
    }

    const payload = {
      project_id: rfqProjectId || 1, // Default project ID
      quotationrequest: rfqRequirementId,
      ...formPayload
    };

    console.log('RFQ Payload:', payload);

    try {
      const response = await createRFQ(payload);
      toast.success('RFQ submitted successfully');
      setIsRFQModalOpen(false);
      setSelectedVendors([]);
      setItemQuantities({});
      setSelectedItemsForRFQ([]);
      setRfqRequirementId(null);
    } catch (error) {
      console.error('Error creating RFQ:', error);
      toast.error(error?.response?.data?.message || error?.message || 'Error creating RFQ');
    }
  };

  // Handle RFQ cancel
  const handleRFQCancel = () => {
    setIsRFQModalOpen(false);
    setSelectedVendors([]);
    setItemQuantities({});
    setSelectedItemsForRFQ([]);
    setRfqRequirementId(null);
  };

  // Check if submit button should be disabled
  const isSubmitDisabled = () => {
    // Check if vendors are selected
    if (selectedVendors.length === 0) return true;

    // Check if quantities are valid
    const hasInvalidQuantities = selectedItemsForRFQ.some((item) => {
      const quantity = itemQuantities[item.id];
      return !quantity || quantity <= 0;
    });

    return hasInvalidQuantities;
  };

  // Helper function to render status with color bar (matching Table component style)
  const renderStatusWithColor = (status) => {
    if (
      ['Rejected', 'rejected', 'Denied', 'denied', 'Inactive', 'inactive', 'Low', 'low'].includes(
        status
      )
    ) {
      return (
        <div className="relative z-0">
          <span className="flex pl-6 overflow-hidden text-sm">{status || '---'}</span>
          <div className="w-[5px] h-[100%] bg-[#C2281B] rounded-t-2xl rounded-r-[3rem] absolute left-[4px] top-[-2px]">
            &nbsp;
          </div>
        </div>
      );
    }

    if (
      [
        'Accepted',
        'accepted',
        'Approved',
        'approved',
        'Active',
        'active',
        'High',
        'high',
        'Completed',
        'completed'
      ].includes(status)
    ) {
      return (
        <div className="relative z-0">
          <span className="flex pl-6 overflow-hidden text-sm">{status || '---'}</span>
          <div className="w-[5px] h-[100%] bg-[#3F8D78] rounded-t-2xl rounded-r-[3rem] absolute left-[4px] top-[-2px]">
            &nbsp;
          </div>
        </div>
      );
    }

    if (
      [
        'Pending',
        'pending',
        'Ongoing',
        'ongoing',
        'Medium',
        'medium',
        'Available',
        'available'
      ].includes(status)
    ) {
      return (
        <div className="relative z-0">
          <span className="flex pl-6 overflow-hidden text-sm">{status || '---'}</span>
          <div className="w-[5px] h-[100%] bg-[#E97B37] rounded-t-2xl rounded-r-[3rem] absolute left-[4px] top-[-2px]">
            &nbsp;
          </div>
        </div>
      );
    }

    // Default case
    return (
      <div className="relative z-0">
        <span className="flex pl-6 overflow-hidden text-sm">{status || '---'}</span>
        <div className="w-[5px] h-[100%] bg-gray-400 rounded-t-2xl rounded-r-[3rem] absolute left-[4px] top-[-2px]">
          &nbsp;
        </div>
      </div>
    );
  };

  return (
    <>
      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this requirement'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">Looks like quotations are requested.</p>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'requirement'}
            onClose={() => setCanDelete(null)}
            data={transformedList}
            type={'requirement'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      {/* RFQ Modal */}
      {isRFQModalOpen && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          isOpen={isRFQModalOpen}
          width={80}
          name="Request for Quotation (RFQ)"
          onClose={() => setIsRFQModalOpen(false)}>
          <RFQForm
            transformedVendors={transformedVendors}
            selectedVendors={selectedVendors}
            handleVendorSelect={handleVendorSelect}
            selectedItemsForRFQ={selectedItemsForRFQ}
            itemQuantities={itemQuantities}
            handleQuantityChange={handleQuantityChange}
            onSubmit={handleRFQSubmit}
            onCancel={handleRFQCancel}
            isSubmitDisabled={isSubmitDisabled}
            isSubmitting={isSubmitting}
          />
        </Modal>
      )}

      <Layout>
        {/* Header */}
        <div
          className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <Header data={{ name: 'Requirements' }} />
        </div>

        <div
          className={`flex z-20 items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 shadow-sm transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <div className="flex gap-8">
            <p
              className={`text-gray-500 py-2 cursor-pointer ${
                activeTab === 'requirements' ? 'border-b-2 border-primary text-primary' : ''
              }`}
              onClick={() => handleTabChange('requirements')}>
              Requirements
            </p>
            <p
              className={`text-gray-500 py-2 cursor-pointer ${
                activeTab === 'emergency' ? 'border-b-2 border-primary text-primary' : ''
              }`}
              onClick={() => handleTabChange('emergency')}>
              Emergency Requirements
            </p>
          </div>
        </div>

        {transformedData && transformedData?.length > 0 ? (
          <>
            {/* Main content */}
            <div
              className={`flex z-5 items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 transition-all duration-300 ease-in-out ${
                collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
              } shadow-sm`}>
              <Search onChange={handleSearchChange} query={searchQuery} />
            </div>

            {/* Grid */}
            <GridWrapper width={100}>
              <div className="mt-[10.3rem]  relative rounded-t-lg flex flex-col items-center gap-4 h-[calc(100vh-12.5rem)] overflow-auto border">
                <div className="overflow-x-auto w-full relative rounded-t-lg">
                  <table className="text-left w-full">
                    <thead className="bg-gray-200 !text-gray-600 w-full sticky top-0 z-20">
                      <tr className="font-normal h-[3rem] w-full">
                        <th className="px-4 py-2 border-b font-normal">Project Name</th>
                        <th className="px-4 py-2 border-b font-normal">Raised By</th>
                        <th className="px-4 py-2 border-b font-normal">Task</th>
                        <th className="px-4 py-2 border-b font-normal">No of Items</th>
                        <th className="px-4 py-2 border-b font-normal">Status</th>
                        <th className="px-4 py-2 border-b font-normal">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transformedData && transformedData?.length > 0 ? (
                        transformedData?.map((requirement, index) => {
                          return (
                            <React.Fragment key={requirement?.id || index}>
                              <tr
                                className="border-b hover:bg-gray-50 bg-white h-[3.5rem] cursor-pointer"
                                onClick={() => handleNavigateRequirement(requirement?.id)}>
                                <td className="px-4 py-2">{requirement?.project_name || '---'}</td>
                                <td className="px-4 py-2">{requirement?.raised_by || '---'}</td>
                                <td className="px-4 py-2">{requirement?.task || '---'}</td>
                                <td className="px-4 py-2">{requirement?.requirements || '---'}</td>
                                <td className="px-4 py-2">
                                  {renderStatusWithColor(requirement?.status)}
                                </td>
                                <td className="px-4 py-2">
                                  <div className="flex justify-start items-center space-x-3 px-3">
                                    {/* View button */}
                                    <div
                                      className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleNavigateRequirement(requirement?.id);
                                      }}>
                                      <img src={viewIcon} alt="view_icon" />
                                    </div>
                                    {/* Delete button */}
                                    <div
                                      className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCheckDelete(requirement?.id);
                                      }}>
                                      <img src={deleteIcon} alt="delete_icon" />
                                    </div>{' '}
                                    {/* RFQ button - only show for emergency tab */}
                                    {activeTab === 'emergency' && (
                                      <div className="relative group">
                                        <Button
                                          customStyle={{
                                            backgroundColor: '#346C75',
                                            color: 'white',
                                            padding: '0.3rem 0.8rem',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontSize: '0.8rem'
                                          }}
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleRFQClick(requirement?.id, e);
                                            console.log('requirement?.id', requirement?.id);
                                          }}>
                                          RFQ
                                        </Button>
                                        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-500 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10">
                                          Request For Quotation
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center py-10 align-middle">
                            <div className="flex flex-col items-center justify-center w-full h-full">
                              <img
                                src={noDataFoundImg}
                                alt="No Data"
                                className="w-32 h-28 mx-auto mb-2 object-contain"
                              />
                              <h2 className="text-lg font-bold text-gray-800 mb-1">
                                No Data Found
                              </h2>
                              <p className="text-gray-600 text-sm">
                                The page you are trying to access has no data.
                                <br />
                                Proceed with adding data.
                              </p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {transformedData && transformedData?.length > 0 && (
                  <PaginationComponent
                    page={currentPage}
                    totalPages={Math.ceil(getAllrequiremnt?.data?.length / itemsPerPage)}
                    onPageChange={handlePageChange}
                    isFetching={isFetching}
                  />
                )}
              </div>
            </GridWrapper>
          </>
        ) : (
          <NoDataFound disabledBtn={true} />
        )}
      </Layout>
    </>
  );
};

export default RequirementList;
